import { render, staticRenderFns } from "./ProfileAndVerification.vue?vue&type=template&id=3394da1b&scoped=true"
import script from "./ProfileAndVerification.vue?vue&type=script&lang=js"
export * from "./ProfileAndVerification.vue?vue&type=script&lang=js"
import style0 from "./ProfileAndVerification.vue?vue&type=style&index=0&id=3394da1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3394da1b",
  null
  
)

export default component.exports